import { render, staticRenderFns } from "./adkeyword.vue?vue&type=template&id=faeb7a8c&scoped=true"
import script from "./adkeyword.vue?vue&type=script&lang=js"
export * from "./adkeyword.vue?vue&type=script&lang=js"
import style0 from "./adkeyword.vue?vue&type=style&index=0&id=faeb7a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faeb7a8c",
  null
  
)

export default component.exports